// This is a basic component to render a staging or production streamlit app in an iframe
// This differs from ExperimentalIFrame in the following ways:
// 1. It does not require a patient context.
// 2. It does not have an accordion.
// 3. URL construction is for staging or production streamlit apps rather than incubator space apps.
import { useFlags } from 'domains/launchdarkly/hooks'
import { useState } from 'react'
import { Alert } from 'ui/baseComponents'

const constructStreamlitUrl = (streamlitConfig, widget) => {
  let proto = 'https'
  if (streamlitConfig.secure === false) {
    proto = 'http'
  }
  let port = ''
  if (streamlitConfig.port && streamlitConfig.port !== '') {
    port = `:${streamlitConfig.port}`
  }
  return `${proto}://${streamlitConfig.host}${port}/${widget}`
}

const ExperimentalIFrameBasic = ({
  widget = '',
  width = '100%',
  height = '100%',
}) => {
  const { experimentalWebComponentsVisible } = useFlags()

  const [showVPNAlert, setShowVPNAlert] = useState(true)

  if (!experimentalWebComponentsVisible || !widget) {
    return null
  }

  const { config } = window.Rune.Carrot
  const { streamlit } = config

  const src = constructStreamlitUrl(streamlit, widget)

  return (
    <>
      {showVPNAlert ? (
        <div style={{ padding: '2rem' }}>
          <Alert severity="warning">Please check your VPN.</Alert>
        </div>
      ) : null}

      <iframe
        {...{
          width,
          height: showVPNAlert ? '0' : height,
          frameBorder: '0',
          src: src,
          allow: 'clipboard-read; clipboard-write',
          title: widget,
          'data-cy': 'experimental-iframe',
          onLoad: () => setShowVPNAlert(false),
        }}
      />
    </>
  )
}

export default ExperimentalIFrameBasic
